import { EditorialQuote } from '../types/editorial-quote.type';
import { EditorialStep } from '../types/editorial-step.type';
import { EditorialValueCard } from '../types/editorial-value-card.type';

import valueIllustration from '../../assets/img/produits_sains-1.png';
import clarityIllustration from '../../assets/img/val_conv_3.png';
import recipesIllustration from '../../assets/img/produits_sains-3.png';
import founderPortrait from '../../assets/img/adrien.png';
import farmerPhotograph from '../../assets/img/produits_sains-producteur.png';
import organicLabel from '../../assets/img/produits_sains-logo_AB.png';

// Contenu relevé sur la page legacy /nos-produits (src/views/Front/NosValeurs/NosProduits.js).
export const OUR_PRODUCTS_HERO = {
  // Le legacy coupe une seule phrase en `h1` puis `h2` ; le surtitre du hero passant au-dessus du
  // titre, la garder en deux morceaux l'aurait fait lire à l'envers.
  title: 'Des produits sains pour une terre préservée',
  lead:
    "Depuis plus de 10 ans, Bio Culture s'engage au quotidien pour une agriculture biologique, contrôlée et certifiée.",
  highlight: "Pour vous garantir une traçabilité sans faille du champ jusqu'à votre assiette.",
};

export const OUR_PRODUCTS_STEPS: EditorialStep[] = [
  { label: 'Arrivages chaque matin' },
  { label: 'Paniers préparés avec amour', operator: '+' },
  { label: 'Le sourire de nos clients', operator: '=' },
];

export const OUR_PRODUCTS_CARDS: EditorialValueCard[] = [
  {
    illustration: valueIllustration,
    illustrationAlt: 'Des légumes de qualité',
    lead: 'Redonner de la valeur au végétal, en proposant des produits de haute qualité',
  },
  {
    illustration: clarityIllustration,
    illustrationAlt: 'Une étiquette précisant origine et label',
    lead: 'Donner une information claire à nos clients, sur l’origine comme sur le label bio',
  },
  {
    illustration: recipesIllustration,
    illustrationAlt: 'Un plat préparé à partir du panier',
    lead: 'Valoriser les produits à travers des recettes et des conseils',
  },
];

export const OUR_PRODUCTS_FOUNDER: EditorialQuote = {
  quote:
    "L'histoire d'un produit, son mode de production biologique, son origine, font que l'on se nourrit en prenant conscience des bienfaits qu'il nous apporte. Notre consommation prend alors une toute autre dimension ! Le défi de Bio Culture : vous faire re-découvrir le goût des fruits et des légumes et vous apporter la créativité pour les cuisiner !",
  author: 'Adrien Gazeau',
  role: 'Fondateur',
  portrait: founderPortrait,
  portraitAlt: 'Adrien Gazeau, fondateur de Bio Culture',
};

export const OUR_PRODUCTS_PARTNERS = {
  title: 'Bio Culture est partenaire de plus de 30 agriculteurs bio en Île-de-France',
  photograph: farmerPhotograph,
  photographAlt: 'Un producteur partenaire dans son champ',
  label: organicLabel,
  labelAlt: 'Label Agriculture Biologique',
  certifications: [
    'Nous sommes contrôlés et certifiés par un organisme indépendant deux fois par an.',
    'Nous faisons le choix de la transparence, de la qualité et du développement du réseau local, afin de proposer ce qu’il y a de meilleur. Certification Ecocert FR-BIO-01.',
  ],
};
